import { Box, Link, Typography, styled } from "@mui/material";
import { useExampleStudyAreas } from "hooks/studyAreaHooks";
import { useTranslation } from "react-i18next";

export function ExampleProjects() {
  const { data: exampleProjects } = useExampleStudyAreas();
  const { t } = useTranslation();

  return (
    <StyledBox className="project-section">
      {exampleProjects?.length !== 0 &&
        exampleProjects?.map((exampleProject) => (
          <Box
            className="project"
            key={`${exampleProject.readOnlyUuid}-${exampleProject.location}`}
          >
            <Typography variant="h2">{exampleProject.description}</Typography>
            <Typography>{exampleProject.location}</Typography>
            <Link
              className="open-link"
              href={`/${exampleProject.readOnlyUuid}/measures`}
              target="_blank"
            >
              {t("label.open")}
            </Link>
          </Box>
        ))}
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(4)};

  .project {
    display: flex;
    flex-direction: column;
    min-height: 80px;
    max-width: 250px;
    width: 100%;
    .MuiTypography-h2 {
      font-size: 14px;
    }
    .MuiLink-root {
      margin-top: auto;
      font-weight: 700;
      font-size: 14px;
      margin-right: ${({ theme }) => theme.spacing(2)};
    }

    /* .open-link {
      font-weight: 700;
    } */
  }
`;
